import { render, staticRenderFns } from "./EditRejectMsg.vue?vue&type=template&id=1ec3adb9&scoped=true&"
import script from "./EditRejectMsg.vue?vue&type=script&lang=js&"
export * from "./EditRejectMsg.vue?vue&type=script&lang=js&"
import style0 from "./EditRejectMsg.vue?vue&type=style&index=0&id=1ec3adb9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3adb9",
  null
  
)

export default component.exports